/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleBookingStatus
 */
export interface VehicleBookingStatus {
    /**
     * VehicleBooking id.
     * @type {number}
     * @memberof VehicleBookingStatus
     */
    id: number;
    /**
     * True when the rental is confirmed and its dropoff datetime is in the past.
     * @type {boolean}
     * @memberof VehicleBookingStatus
     */
    isCompleted: boolean;
    /**
     * True when the vehicle booking has been cancelled.
     * @type {boolean}
     * @memberof VehicleBookingStatus
     */
    isCancelled: boolean;
}

/**
 * Check if a given object implements the VehicleBookingStatus interface.
 */
export function instanceOfVehicleBookingStatus(value: object): value is VehicleBookingStatus {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    if (!('isCancelled' in value) || value['isCancelled'] === undefined) return false;
    return true;
}

export function VehicleBookingStatusFromJSON(json: any): VehicleBookingStatus {
    return VehicleBookingStatusFromJSONTyped(json, false);
}

export function VehicleBookingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isCompleted': json['is_completed'],
        'isCancelled': json['is_cancelled'],
    };
}

export function VehicleBookingStatusToJSON(json: any): VehicleBookingStatus {
    return VehicleBookingStatusToJSONTyped(json, false);
}

export function VehicleBookingStatusToJSONTyped(value?: VehicleBookingStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'is_completed': value['isCompleted'],
        'is_cancelled': value['isCancelled'],
    };
}

